import React from 'react';
import PaymentList from "./PaymentList";

export default function PaymentTypeField(props) {
  React.useEffect(() => {
    if (!props.options.some((item) => item.token === props?.value?.token)) {
      const data = props.options?.find?.(x => x);
      props.onChange(data);
    }
  }, [ props.options, props.value ]);

  const selectPayment = (token) =>
    props?.onChange?.(props.options?.find?.(x => x.token === token));

  return (
    <>
      {
        props.options?.length > 0 &&
        <PaymentList
          paymentTypes={props.options}
          deletePaymentMethod={props.delete}
          selectPayment={selectPayment}
          currentPayment={props.value?.token}
        />
      }
    </>
  )
}
